import { Component, effect, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { HomepageService } from '@app/_services/homepage.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { DropcartType } from '../../pages/header/components/dropcart/dropcart.component';
import { SharedModule } from '@app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { HeaderNewModule } from '@app/pages/header-new/header-new.module';
import { FooterModule } from '@app/pages/footer/footer.module';
import { MobileMenuComponent } from '@app/pages/mobile-new/components/mobile-menu/mobile-menu.component';
import { MobileHeaderComponent } from '@app/pages/mobile-new/components/mobile-header/mobile-header.component';
import { GeneralNavigationComponent } from './general-navigation/general-navigation.component';
import { GeneralNavigationService } from './general-navigation/general-navigation.service';
import { SharedService } from '@app/_services/shared.service';

@Component({
    standalone: true,
    imports: [
        SharedModule,
        RouterModule,
        CommonModule,
        HeaderNewModule,
        FooterModule,
        MobileMenuComponent,
        MobileHeaderComponent,
        GeneralNavigationComponent
    ],
    selector: 'app-main',
    templateUrl: './root.component.html',
    styleUrls: ['./root.component.scss']
})
export class RootComponent implements OnInit {
    public headerLayout: 'classic' | 'compact';
    public dropcartType: DropcartType;
    public showGeneralNavMenu: boolean = false;
    public isIframeMode: boolean = false;

    constructor(
        public route: ActivatedRoute,
        private router: Router,
        private homepageService: HomepageService,
        public deviceDetector: DeviceDetectorService,
        private generalNavigationService: GeneralNavigationService,
        private sharedService: SharedService
    ) {
        this.location = this.sharedService.location;
        this.route.data.subscribe(data => {
            this.headerLayout = data.headerLayout;
            this.dropcartType = data.dropcartType || 'dropdown';
        });

        effect(() => {
            this.showGeneralNavMenu = this.generalNavigationService.showMenu;
        });
    }
    location;

    ngOnInit(): void {
        // Check for iframe mode from query params
        this.route.queryParams.subscribe(params => {
            if (params['iframe'] === 'true') {
                this.isIframeMode = true;
                this.sharedService.iframeMode = true;
            }
        });

        // Also subscribe to iframeMode changes
        this.sharedService.iframeMode$.subscribe(mode => {
            this.isIframeMode = mode;
        });
    }
}
